import React from "react";
import { Text, View, Image, Link } from "@react-pdf/renderer";
import { styles } from "./styles";
import { isRealDate } from "../../helpers/date";

export const TextRow = ({ propName, value, type, whatsapp }) => {

    return(
        <View style={styles.textRowContainer}>
            <View style={styles.textRowPropContainer}>
                <Text style={styles.textRowPropName}>{propName}:</Text>
            </View>
            <View style={styles.textRowValueContainer}>
                {!type &&
                    <Text style={styles.textRowValue}>{value}</Text>
                }
                {type === "email" &&
                    <Link wrap={true} style={styles.textRowValueLink} href={`mailto:${value}`}>{value}</Link>
                }
                {type === "visa" &&
                    <View style={styles.textRowMultipleTextContainer}>
                        {value?.b1b2?.status &&
                            <View style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <Text style={styles.textRowMultipleText}>B1/B2</Text>
                                {isRealDate(value?.b1b2?.expiryDate) ?
                                    <Text style={styles.textRowMultipleDate}>(exp. {value.b1b2.expiryDate})</Text>
                                :
                                    <View></View>
                                }
                            </View>
                        }
                        {value?.c1d?.status &&
                            <View style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <Text style={styles.textRowMultipleText}>C1/D</Text>
                                {isRealDate(value?.c1d?.expiryDate) ?
                                    <Text style={styles.textRowMultipleDate}>(exp. {value.c1d.expiryDate})</Text>
                                :
                                    <View></View>
                                }
                            </View>
                        }
                        {value?.schengen?.status &&
                            <View style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <Text style={styles.textRowMultipleText}>Schengen</Text>
                                {isRealDate(value?.schengen?.expiryDate) ?
                                    <Text style={styles.textRowMultipleDate}>(exp. {value.schengen.expiryDate})</Text>
                                :
                                    <View></View>
                                }
                            </View>
                        }
                        {value?.greenCard?.status &&
                            <View style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <Text style={styles.textRowMultipleText}>Green Card</Text>
                                {isRealDate(value?.greenCard?.expiryDate) ?
                                    <Text style={styles.textRowMultipleDate}>(exp. {value.greenCard.expiryDate})</Text>
                                :
                                    <View></View>
                                }
                            </View>
                        }
                    </View>
                }
            </View>
            {whatsapp &&
                <Image style={styles.textRowContainerImage} source={require("../../assets/pngs/whatsapp.png")} />
            }   
        </View>
    );

}

export const SectionSeparator = ({ title, accentColor }) => {

    const barStyle = accentColor
        ? [styles.sectionSeparatorBar, { backgroundColor: accentColor }]
        : styles.sectionSeparatorBar;

    return(
        <View style={styles.sectionSeparatorContainer} wrap={false} minPresenceAhead={60}>
            <View style={barStyle} />
            <Text style={styles.sectionSeparatorTitle}>{(title || "").toUpperCase()}</Text>
            <View style={styles.sectionSeparatorRule} />
        </View>
    );

}